import {
  FetchOrderNoInfoFailureAction,
  FetchOrderNoInfoRequestAction,
  FetchOrderNoInfosResetAction,
  FetchOrderNoInfosSuccessAction,
  OrderNoInfo,
  SalaryCardActions,
  SalaryCardActionTypes,
} from 'store/types/salaryCard'
import { Dispatch } from 'redux'
import { fetchOrderNoInfoService } from '../../../services/SalaryCards/salaryCards'
import { GlobalErrorActions } from 'store/types/globalError'
import { setGlobalErrorAction } from '../globalError'

export const fetchOrderNoInfoRequest = (): FetchOrderNoInfoRequestAction => ({
  type: SalaryCardActionTypes.FETCH_ORDER_NO_INFO_REQUEST,
})

export const fetchOrderNoInfoReset = (): FetchOrderNoInfosResetAction => ({
  type: SalaryCardActionTypes.FETCH_ORDER_NO_INFO_RESET,
})

export const fetchOrderNoInfoSuccess = (
  orderNoInfo: OrderNoInfo
): FetchOrderNoInfosSuccessAction => ({
  type: SalaryCardActionTypes.FETCH_ORDER_NO_INFO_SUCCESS,
  payload: orderNoInfo,
})

export const fetchOrderNoInfoFailure = (
  error: any
): FetchOrderNoInfoFailureAction => ({
  type: SalaryCardActionTypes.FETCH_ORDER_NO_INFO_FAILURE,
  payload: error,
})

export const fetchOrderNoInfo = () => {
  return async (dispatch: Dispatch<SalaryCardActions | GlobalErrorActions>) => {
    dispatch(fetchOrderNoInfoRequest())

    try {
      const data = await fetchOrderNoInfoService()
      dispatch(fetchOrderNoInfoSuccess(data))
    } catch (error) {
      dispatch(fetchOrderNoInfoFailure(error.message))
      dispatch(setGlobalErrorAction(error.message ?? ''));
      
    }
  }
}
